//
// My documents
//

import { easepick } from '@easepick/core'
import { RangePlugin } from '@easepick/range-plugin'
import { AmpPlugin } from '@easepick/amp-plugin'
import { debounce } from 'debounce'
import { getResults } from '../api/documents'
import { startLoader, stopLoader } from '../filter-common/filterLoaders'
import 'twbs-pagination'
;(($) => {
    $(() => {
        let module = $('.my-documents')

        if (!module.length) return

        const filterButtonSelector = $('.my-documents__filter-button')
        const filterClearButtonSelector = $('.my-documents__clear-button')
        const filterSelector = $('.my-documents__filters-advanced')
        const filterFormSelector = $('.my-documents__form')[0]
        const filterInputSelectors = $('.my-documents__form input')
        const allSortableHeaders = $('.my-documents__results-table-header.sortable')
        const resultsTableSelector = $('.my-documents__results-table tbody')
        const resultsPaginationSelector = $('.my-documents__results-pagination')
        const selectAllCheckboxesSelector = $('.my-documents__select-all')
        const downloadButtonSelector = $('.my-documents__download-button')
        const messageSelector = $('.my-documents__message')

        for (let selectAllCheckbox of selectAllCheckboxesSelector) {
            selectAllCheckbox.addEventListener('change', (event) => {
                const checkboxStatus = event.target.checked
                const targetId = event.target.id.split('_')[0]
                const tableItems = resultsTableSelector.find(`[id*="${targetId}"]`)
                for (let singleCheckbox of tableItems) {
                    $(singleCheckbox).prop('checked', checkboxStatus)
                }
            })
        }

        const resetAllCheckboxes = () => {
            for (let selectAllCheckbox of selectAllCheckboxesSelector) {
                $(selectAllCheckbox).prop('checked', false)
            }
        }

        const filterDatepicker = new easepick.create({
            element: document.getElementById('my_documents_datepicker'),
            css: [
                'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.0/dist/index.css',
                'https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.0/dist/index.css',
                '/',
            ],
            setup(picker) {
                picker.on('select', (e) => {
                    const start = picker.getStartDate();
                    const end = picker.getEndDate();
                    if (start && end) {
                        $('#my_documents_datepicker').trigger('apply.easepick', [picker, start, end]);
                    }
                });
            },
            AmpPlugin: {
                dropdown: {
                    months: true,
                    years: true,
                },
                resetButton: true,
                darkMode: false,
            },
            RangePlugin: {
                tooltip: false,
            },
            zIndex: 9999,
            grid: 2,
            calendars: 2,
            lang: document.querySelector('html').getAttribute('data-locale').replace('_', '-'),
            plugins: [RangePlugin, AmpPlugin],
        })



        const getFilterDate = () => {
            const rawFrom = filterDatepicker.getStartDate()
            const rawTo = filterDatepicker.getEndDate()
            return {
                from: rawFrom ? rawFrom.format('YYYY-MM-DD') : '',
                to: rawTo ? rawTo.format('YYYY-MM-DD') : '',
            }
        }

        
      

       
    })
})(jQuery)
